import { TopRectangles } from '@emerald-works-nova/auth'
import { Grid } from '@mui/material'
import React from 'react'
import { Outlet } from 'react-router-dom'
import { FooterPublic } from '../../components'
import { useStyles } from './style'

const SecondaryLayout = () => {
  const classes = useStyles()
  return (
    <>
      <div className={classes.rectBarContainer}>
        <TopRectangles />
      </div>
      <Grid
        container
        direction='column'
        wrap='nowrap'
        className={classes.container}
      >
        <Grid item className={classes.mainContainer} xs={12}>
          <main>
            <Outlet />
          </main>
        </Grid>
        <Grid item className={classes.footerContainer}>
          <footer>
            <FooterPublic />
          </footer>
        </Grid>
      </Grid>
    </>
  )
}

export default SecondaryLayout
